import React from 'react'
import { Flex, Text, Skeleton, FlexProps } from 'vvs-uikit'
import styled from 'styled-components'
import { space, SpaceProps } from 'styled-system'

import useCountdown from 'hooks/useCountdown'

// Types & Components
interface ContainerProps extends FlexProps, SpaceProps {}
export interface StartFromProps extends ContainerProps {
  startFrom: string
}
const Container = styled(Flex)<ContainerProps>`
  align-items: center;
  ${space}
`

const TimePiece = ({ value = '', unit = '' }) => {
  return (
    <Flex alignItems="end">
      {React.Children.toArray(
        Array.from(value).map((char) => (
          <Text width="8px" textAlign="center" marginRight="1px">
            {char}
          </Text>
        )),
      )}
      <Text fontSize="14px">{unit}</Text>
    </Flex>
  )
}

const Countdown: React.FC<StartFromProps> = ({ startFrom, ...props }) => {
  const { timeExcerpt } = useCountdown(startFrom)
  return (
    <Container {...props}>
      {/* {timeExcerpt.length > 0 ? <Text whiteSpace="nowrap"> {timeExcerpt} </Text> : <Skeleton width={60} />} */}
      <Flex flexWrap="nowrap">
        {timeExcerpt.length > 0 ? (
          timeExcerpt.map(([unit, value], index, arr) => {
            const isLastPiece = index === arr.length - 1
            return (
              <>
                <TimePiece value={value.toString()} unit={unit} />
                {isLastPiece || (
                  <Text marginLeft="2px" marginRight="1px">
                    :
                  </Text>
                )}
              </>
            )
          })
        ) : (
          <Skeleton width={60} />
        )}
      </Flex>
    </Container>
  )
}
export default Countdown
